<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading || loading) {
<div class="kbm-search-loading">
  <p-progressSpinner></p-progressSpinner>
</div>
}
@if (mailComposeLoading) {
<div class="kbm-search-loading">
  <div class="d-flex flex-column align-items-center gap-2">
    <p-progressSpinner></p-progressSpinner>
    <span class="text-white">Preparing email...</span>
  </div>
</div>
}
<!--<h2>Owner Statements</h2>-->

<!-- First-visit onboarding banner — dismissible, persists in localStorage -->
<div *ngIf="showOnboardingBanner" class="onboarding-banner">
  <div class="onboarding-content">
    <i class="pi pi-info-circle onboarding-icon"></i>
    <div class="onboarding-text">
      <strong>Welcome to Owner Statements.</strong>
      The dashboard tiles below show what's complete and what still needs work for the current statement period. Hover the
      <i class="pi pi-info-circle"></i> icon on any tile for plain-English help.
      <a href="/owner-statements-help" target="_blank">Read the full Statement Production Guide →</a>
    </div>
    <button pButton type="button" label="Got it" icon="pi pi-check"
            class="p-button-sm onboarding-dismiss"
            (click)="dismissOnboarding()"></button>
  </div>
</div>

<app-statement-dashboard
  [month]="dashboardMonth"
  [year]="dashboardYear"
  (filterByStatus)="onDashboardStatusFilter($event)"
  (showOnlyUnemailed)="onDashboardShowUnemailed()"
  (reloadStatementsList)="loadLazy(lazyLoadEvent)"
  (criticalBlockerCount)="onBlockerCount($event)">
</app-statement-dashboard>

<div class="reservationsTable owner-statements-container">
  <p-table #pt [value]="reservations" class="owner-statements-table" [scrollable]="true"
    scrollHeight="calc(100vh - 220px)" [paginator]="true" [rows]="300" [rowsPerPageOptions]="[300,600,900]"
    [totalRecords]="recordTotal" [lazy]="true" (onLazyLoad)="loadLazy($event)" sortMode="multiple"
    [multiSortMeta]="multiSortMeta" selectionMode="single"
    [globalFilterFields]="['guestProfileVO.lastName','guestProfileVO.firstName','guestProfileVO.emailAddress','reservationId','orderId','reservationConfId','saleDate','checkInDate','checkOutDate','shortTermRentalVO.propertyCode','orderVO.orderIdMask']"
    [filterDelay]="0" [(selection)]="reservation" dataKey="reservationId" (onRowSelect)="onRowSelect($event)"
    showCurrentPageReport="true" [responsive]="true" styleClass="p-datatable-striped"
    currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
    [style]="{'width': '100%', 'table-layout': 'auto'}">

    <ng-template pTemplate="caption">
      <div class="flex justify-content-between">
        <h1>Owner Statements</h1>
        <!--<div class="mr-2">
        <span class="p-input-icon-right">
          <i class="pi pi-search"></i>
          <input #global pInputText type="text" [(ngModel)]="searchName" (input)="pt.filterGlobal($event.target.value, 'contains')"
            placeholder="Search" />
        </span>
        <button pButton pRipple class="ml-3 p-button-text"
          style="font-size: 100%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="onAdvanceSearch()">Advance Search</button>

        &lt;!&ndash; <button pButton label="Clear" class="ml-2 p-button-outlined" icon="pi pi-filter-slash"
      (click)="clear(pt);"></button> &ndash;&gt;
    </div>-->
        <!-- <div class="mr-2">
    <span class="p-input-icon-right">
      <i class="pi pi-search"></i>
      <input #global pInputText type="text" [(ngModel)]="searchName" (input)="pt.filterGlobal($event.target.value, 'contains')"
        placeholder="Search" />
    </span>
  </div> -->
        <div class="d-block text-end">
          <span>
            <!--<app-import-export (dataAndTagsSelected)="dataAndTagSelected($event)" [tagsourceForInput]="50" [dataRetrived]="reservations"
    (exportDataSelected)="exportSelected($event)" importEnabled="false" [sampleFileLink]="sampleLink" [columns]="columns" [importDisabled]="true"></app-import-export>-->
            <!--clear filters-->

            <button pButton pRipple class="p-button-text mt-2"
              style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="reloadPage()">Clear Filters</button>

            <!--<button pButton pRipple class="p-button-text" title="If you need help or are experiencing any difficulties, please call Dipesh on Ring Central at extension 907."
    style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
  (click)="openHelpAlert()">Need Help?</button>-->

            <!--add new-->
            <!-- <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
routerLink="/reservation-add">New Reservation +</button> -->
            <button pButton pRipple class="p-button-text mt-2"
              style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="openGenerateStatementByDatePopUp()">Generate Statement By Date</button>

            <div class="d-inline-flex align-items-center me-2 mt-2">
              <p-multiSelect #locationMultiSelect [dropdownIcon]="'fa fa-caret-down'" class="text-start me-2"
                [options]="constantService.locations" optionLabel="name" optionValue="locationId"
                selectedItemsLabel="Locations"
                [placeholder]="'Select Locations'" [filter]="false" appendTo="body"
                [(ngModel)]="selectedLocationIds" (onChange)="onLocationFilterChange($event.value)"></p-multiSelect>
            </div>

            <button pButton pRipple class="p-button me-2 mt-2" style="padding: 0.643rem 0.75rem !important;"
              (click)="openBulkUpdateDialog()">Bulk Update</button>

            <button pButton pRipple class="p-button mt-2" style="padding: 0.643rem 0.75rem !important; margin-right:10px"
              (click)="openGenerateStatementPopUp()">Generate Statement</button>

            <button pButton pRipple class="p-button mt-2" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="openGenerateBulkStatementPopUp()">Generate Bulk Statement</button>

            <button pButton pRipple class="p-button mt-2" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="openRegeneratePopUp('bulk')">Regenerate Bulk Statement</button>

            <button pButton pRipple class="p-button mt-2" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="openRegeneratePopUp('expenses')">Regenerate Statement Expenses</button>

            <button pButton pRipple class="p-button-danger mt-2"
              style="padding: 0.643rem 0.75rem !important; margin-right:10px;" icon="pi pi-send"
              (click)="openBulkMailDialog()">&nbsp;Bulk Mail Statements{{ selectedCount > 0 ? ' (' + selectedCount + ')' : '' }}</button>

            <button pButton pRipple type="button" class="p-button-success mt-2"
              style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
              [icon]="exportToExcelLoading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel'"
              [label]="exportToExcelLoading ? 'Exporting...' : 'Export to Excel'" (click)="exportToExcel()"
              [disabled]="exportToExcelLoading">
            </button>

            <a class="p-button mt-2 help-toolbar-link"
               style="padding: 0.643rem 0.75rem !important; background: #c9a84c !important; color: #1a2744 !important; border: none !important; text-decoration: none; font-weight: 600;"
               href="/owner-statements-help" target="_blank"
               pTooltip="Open Statement Production Guide in a new tab" tooltipPosition="left">
              <i class="pi pi-question-circle"></i>&nbsp;How To Guide
            </a>

          </span>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr [style]="{'min-height':'50px', 'height':'50px'}">

        <th rowspan="2" class="text-center" [style]="{'width': '40px', 'min-width': '40px'}">
          <p-checkbox [binary]="true" [(ngModel)]="selectAllChecked" (onChange)="toggleSelectAll()"></p-checkbox>
        </th>

        <th [pSortableColumn]="'startDate'" class="col-month-year" [style]="{'min-width': '110px', 'width': '110px'}">
          Month/Year
          <p-sortIcon [field]="'startDate'"></p-sortIcon>
        </th>

        <th [pSortableColumn]="'propertyCode'" class="col-property" [style]="{'min-width': '135px'}">Property
          <p-sortIcon [field]="'propertyCode'"></p-sortIcon>
        </th>

        <th [pSortableColumn]="'stmtStatus'" [style]="{'width': 'auto'}">Status
          <p-sortIcon [field]="'stmtStatus'"></p-sortIcon>
        </th>

        <th colspan="6" class="text-center">
          Nights
        </th>

        <th [pSortableColumn]="'propertyManagementCommissionRate'" rowspan="2" class="text-center border-left-thick">
          Mgmt Comm.
          <p-sortIcon [field]="'propertyManagementCommissionRate'"></p-sortIcon>
        </th>

        <th [pSortableColumn]="'stmtSummeryAPI.rentalRevenue'" rowspan="2" class="text-center bg-success border-left-thick">
          Rental Revenue
          <p-sortIcon [field]="'stmtSummeryAPI.rentalRevenue'"></p-sortIcon>
        </th>

        <th [pSortableColumn]="'stmtSummeryAPI.paymentToOwner'" rowspan="2" class="text-center border-left-thick">
          Payment to owner
          <p-sortIcon [field]="'stmtSummeryAPI.paymentToOwner'"></p-sortIcon>
        </th>

        <th colspan="3" class="text-center bg-info">Maintenance & Housekeeping
        </th>







        <th colspan="5" class="text-center bg-warning border-left-thick">
          Expenses
        </th>

        <th colspan="2" class="text-center border-left-thick">
          Balance
        </th>

        <th colspan="2" class="text-center bg-secondary border-left-thick">
          Reconciliation
        </th>

        <th class="text-center bg-secondary border-left-thick">
          Mail Stats
        </th>

        <th colspan="2" class="text-center bg-secondary border-left-thick">
          Dates
        </th>


        <th colspan="2" class="text-center bg-info">Maintenance
        </th>

        <th colspan="2" class="text-center bg-info">Housekeeping
        </th>

        <th rowspan="2" class="text-center">Owner Stmt Id
        </th>



        <!-- <th [pSortableColumn]="'startDate'">Start Date
    <p-sortIcon [field]="'startDate'"></p-sortIcon>
  </th>
  <th [pSortableColumn]="'endDate'">End Date
    <p-sortIcon [field]="'endDate'"></p-sortIcon>
  </th> -->



      </tr>
      <tr>
        <th class="col-month-year" [style]="{'min-width': '110px', 'width': '110px'}">
          <p-calendar appendTo="body" [(ngModel)]="selectedMonthDate" view="month" dateFormat="M yy" [showIcon]="false"
            [readonly]="true" [style]="{'width':'100%','max-width':'100%'}" (ngModelChange)="onMonthYearSelect($event)"
            placeholder="MM/YYYY" [showButtonBar]="true">
          </p-calendar>
        </th>
        <th class="col-property" [style]="{'min-width': '135px'}">
          <p-multiSelect dropdownIcon="fa fa-caret-down" [style]="{'width':'100%','max-width':'100%'}"
            [options]="properties" optionLabel="propertyCode" optionValue="shortTermRentalId"
            [(ngModel)]="selectedPropertyIds"
            (onChange)="onPropertyFilterChange($event.value)" appendTo="body"></p-multiSelect>
        </th>
        <th [style]="{'width': 'auto'}">
          <p-multiSelect dropdownIcon="fa fa-caret-down" [style]="{'width':'100%','max-width':'100%'}"
            [options]="ownerStmtService.stmtStatus" defaultLabel="Status"
            (onChange)="onStatusFilterChange($event.value)" appendTo="body"></p-multiSelect>
        </th>

        <th [pSortableColumn]="'stmtSummeryAPI.paidNights'" class="text-center">
          Total# <p-sortIcon [field]="'stmtSummeryAPI.paidNights'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'stmtSummeryAPI.occupancyRate'" class="text-center">
          Occ(%) <p-sortIcon [field]="'stmtSummeryAPI.occupancyRate'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'guestNight'" class="bg-grey text-center">
          G# <p-sortIcon [field]="'guestNight'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'ownerNights'" class="bg-pink text-center">
          O# <p-sortIcon [field]="'ownerNights'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'ownerGuestNights'" class="bg-light-pink text-center">
          OG# <p-sortIcon [field]="'ownerGuestNights'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'maintenanceNights'" class="bg-dark-grey text-center">
          Maint# <p-sortIcon [field]="'maintenanceNights'"></p-sortIcon>
        </th>

        <!-- <th class="bg-success text-center border-left-thick">
  Rents
</th> -->
        <!-- <th class="bg-success text-center">
Tax
</th>
<th class="bg-success text-center">
  Maint
</th>
<th class="bg-success text-center">
  Hskp
</th>
<th class="bg-success text-center">
  Total
</th> -->

        <!-- <th class="text-center">
Net
</th>
<th class="text-center">
  To Owner
</th> -->

        <th [pSortableColumn]="'stmtSummeryAPI.maintenanceAndHousekeepingTotal'" class="text-center border-left-thick bg-info">
          Total <p-sortIcon [field]="'stmtSummeryAPI.maintenanceAndHousekeepingTotal'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'stmtSummeryAPI.maintenanceAndHousekeepingPaidByKbmTotal'" class="text-center bg-info">
          KBM Paid <p-sortIcon [field]="'stmtSummeryAPI.maintenanceAndHousekeepingPaidByKbmTotal'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'stmtSummeryAPI.maintenanceAndHousekeepingPaidByOwnerTotal'" class="text-center bg-info">
          Owner Paid <p-sortIcon [field]="'stmtSummeryAPI.maintenanceAndHousekeepingPaidByOwnerTotal'"></p-sortIcon>
        </th>


        <th [pSortableColumn]="'stmtSummeryAPI.mgntExpense'" class="bg-warning border-left-thick text-center">
          Mgmt <p-sortIcon [field]="'stmtSummeryAPI.mgntExpense'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'stmtSummeryAPI.maintenancePaidByOwnerTotal'" class="bg-warning text-center">
          Maint <p-sortIcon [field]="'stmtSummeryAPI.maintenancePaidByOwnerTotal'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'stmtSummeryAPI.housekeepingPaidByOwnerTotal'" class="bg-warning text-center">
          Hksp <p-sortIcon [field]="'stmtSummeryAPI.housekeepingPaidByOwnerTotal'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'stmtSummeryAPI.taxExpense'" class="bg-warning text-center">
          Tax <p-sortIcon [field]="'stmtSummeryAPI.taxExpense'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'stmtSummeryAPI.totalExpense'" class="bg-warning text-center">
          Total <p-sortIcon [field]="'stmtSummeryAPI.totalExpense'"></p-sortIcon>
        </th>

        <th [pSortableColumn]="'startingBalance'" class="text-center border-left-thick">
          Starting <p-sortIcon [field]="'startingBalance'"></p-sortIcon>
        </th>

        <th class="text-center">
          Ending
        </th>


        <th [pSortableColumn]="'stmtReconcile.discrepancyAmount'" class="text-center bg-secondary border-left-thick">
          Discrepancy <p-sortIcon [field]="'stmtReconcile.discrepancyAmount'"></p-sortIcon>
        </th>
        <th [pSortableColumn]="'stmtReconcile.expenseMatch'" class="text-center bg-secondary">
          Match <p-sortIcon [field]="'stmtReconcile.expenseMatch'"></p-sortIcon>
        </th>

        <th class="text-center bg-secondary border-left-thick">Stats</th>


        <th class="text-center bg-secondary border-left-thick">
          Created
        </th>
        <th class="text-center bg-secondary">
          Last Updated
        </th>


        <th class="text-center bg-info">
          KBM Paid
        </th>
        <th class="text-center bg-info">
          Owner Paid
        </th>

        <th class="text-center bg-info">
          KBM Paid
        </th>
        <th class="text-center bg-info">
          Owner Paid
        </th>

        <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
[(ngModel)]="defaultStartDate"
(input)="pt.filter($event.target.value, 'startDate', 'in')"></th>
<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="date"
  [(ngModel)]="defaultEndDate"
(input)="pt.filter($event.target.value, 'endDate', 'in')"></th> -->

      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-reservation>
      <tr [pSelectableRow]="reservation"
        [ngClass]="{'reconcile-row-matched': reservation?.stmtReconcile?.expenseMatch === true, 'reconcile-row-mismatch': reservation?.stmtReconcile?.expenseMatch === false}">
        <td class="text-center" [style]="{'width': '40px', 'min-width': '40px'}" (click)="$event.stopPropagation()">
          <p-checkbox [binary]="true" [ngModel]="isStatementSelected(reservation?.ownerStmtId)"
            (onChange)="toggleStatementSelection(reservation?.ownerStmtId)"></p-checkbox>
        </td>
        <td class="col-month-year text-nowrap cursor-pointer" (click)="openStmtCm($event, stmtContextMenu, reservation)"
          [style]="{'min-width': '110px'}">{{reservation?.startDate | date:'MMM y'}}
          <span style="cursor: pointer;">
            <i class="pi pi-align-justify" aria-hidden="true" style="margin-left: 5px;"></i>
          </span>
        </td>
        <td class="col-property col-property-with-icon" (click)="openTopicMessages($event, reservation)"
          [style]="{'min-width': '135px'}">
          <div class="d-flex align-items-center justify-content-between">
            <div class="col-property-text">{{reservation.propertyCode}}</div>
            <div>
              <i class="pi pi-envelope topic-msg-icon me-2"
                [ngClass]="{'text-success': reservation?.topicMsgStats?.messageCount > 0, 'text-danger': reservation?.topicMsgStats?.messageCount === 0}"
                title="View statement messages" aria-hidden="true"></i>
              <i class="pi pi-send topic-msg-icon text-primary cursor-pointer" title="Mail statement to owner"
                aria-hidden="true" (click)="sendStatementEmail($event, reservation)"></i>
            </div>
          </div>
          @if (!selectedLocationIds || selectedLocationIds.length !== 1) {
          <div class="col-property-text font-small">{{getLocationName(reservation.locationId)}}</div>
          }
        </td>
        <td (click)="$event.stopPropagation()">
          <span class="p-float-label w-100">
            <p-dropdown appendTo="body" dropdownIcon="fa fa-caret-down" class="w-100"
              [options]="ownerStmtService.stmtStatus" [(ngModel)]="reservation.stmtStatus"
              [ngModelOptions]="{ standalone: true }" (onChange)="updateOwnerStmtStatus(reservation, $event.value)"
              optionLabel="label" optionValue="value" [filter]="false"></p-dropdown>
          </span>
        </td>

        <!-- Nights Data  -->

        <td class="text-center">
          {{(reservation?.stmtSummeryAPI?.paidNights || 0)}}
        </td>
        <td class="text-center">
          {{(reservation?.stmtSummeryAPI?.occupancyRate || 0) | number:'1.0-0'}} %
        </td>
        <td class="bg-grey text-center">
          {{(reservation?.guestNight || 0)}}
        </td>
        <td class="bg-pink text-center">
          {{(reservation?.ownerNights || 0)}}
        </td>
        <td class="bg-light-pink text-center">
          {{(reservation?.ownerGuestNights || 0)}}
        </td>
        <td class="bg-dark-grey text-center">
          {{(reservation?.maintenanceNights || 0)}}
        </td>


        <td class="text-center">
          {{((reservation?.propertyManagementCommissionRate || 0) * 100) | number:'1.0-0'}} %
        </td>



        <td class="text-center border-left-thick">
          {{(reservation?.stmtSummeryAPI?.rentalRevenue || 0) | statementAmount}}
        </td>

        <!-- <td class="text-center border-left-thick">
    {{(reservation?.stmtSummeryAPI?.totalRevenueWithExpenseCredit || 0)| statementAmount}}
  </td> -->
        <td class="text-center border-left-thick">
          {{(reservation?.stmtSummeryAPI?.paymentToOwner || 0)| statementAmount}}
        </td>


        <!-- <td class="text-center">
  {{(reservation?.stmtSummeryAPI?.taxRevenue || 0)| statementAmount}}
</td>
<td class="text-center">
  {{(reservation?.stmtSummeryAPI?.maintenanceCreditTotal || 0)| statementAmount}}
</td>
<td class="text-center">
  {{(reservation?.stmtSummeryAPI?.housekeepingCreditTotal || 0)| statementAmount}}
</td>
<td class="text-center">
  {{(reservation?.stmtSummeryAPI?.totalRevenue || 0)| statementAmount}}
</td> -->






        <td class="text-center border-left-thick">
          {{(reservation?.stmtSummeryAPI?.maintenanceAndHousekeepingTotal || 0)| statementAmount}}
        </td>
        <td class="text-center">
          {{(reservation?.stmtSummeryAPI?.maintenanceAndHousekeepingPaidByKbmTotal || 0)| statementAmount}}
        </td>
        <td class="text-center">
          {{(reservation?.stmtSummeryAPI?.maintenanceAndHousekeepingPaidByOwnerTotal || 0)| statementAmount}}
        </td>


        <td class="border-left-thick text-center">
          {{(reservation?.stmtSummeryAPI?.mgntExpense || 0)| statementAmount}}
        </td>
        <td class="text-center">
          {{(reservation?.stmtSummeryAPI?.maintenancePaidByOwnerTotal || 0) | statementAmount}}
        </td>
        <td class="text-center">
          {{(reservation?.stmtSummeryAPI?.housekeepingPaidByOwnerTotal || 0)| statementAmount}}
        </td>
        <td class="text-center">
          {{(reservation?.stmtSummeryAPI?.taxExpense || 0)| statementAmount}}
        </td>
        <td class="text-center">
          {{(reservation?.stmtSummeryAPI?.totalExpense || 0)| statementAmount}}
        </td>


        <td class="text-center border-left-thick">
          {{(reservation?.startingBalance || 0) | statementAmount}}
        </td>

        <td class="text-center">
          {{(reservation?.stmtSummeryAPI?.endingBalance || 0) | statementAmount}}
        </td>



        <td class="text-center border-left-thick" (click)="openExpenseList($event, reservation)">
          {{(reservation?.stmtReconcile?.discrepancyAmount || 0)| statementAmount}}
        </td>
        <td class="text-center reconcile-cell-link" (click)="openExpenseList($event, reservation)"
          [title]="'View expenses for this statement'">
          @if (reservation?.stmtReconcile?.expenseMatch === true) {
          <i class="pi pi-check-circle reconcile-icon-matched" aria-hidden="true"></i>
          }
          @if (reservation?.stmtReconcile?.expenseMatch === false) {
          <i class="pi pi-times-circle reconcile-icon-mismatch" aria-hidden="true"></i>
          }
          @if (reservation?.stmtReconcile?.expenseMatch === null) {
          <span class="reconcile-icon-unknown">—</span>
          }
        </td>

        <td class="mail-stats-cell text-nowrap border-left-thick">
          @if (reservation?.topicMsgStats; as stats) {
          @for (entry of mailStatEntries; track entry) {
          @if (stats[entry.key] && stats[entry.key] > 0) {
          <span class="mail-stat-item mail-stat-{{ entry.key }}"
                [pTooltip]="entry.toolTip + ': ' + stats[entry.key]" tooltipPosition="top">
            <i class="pi {{ entry.icon }}" [attr.aria-label]="entry.label"></i>
            <span class="mail-stat-badge">{{ stats[entry.key] | number }}</span>
          </span>
          }
          }
          }
        </td>

        <td class="text-center border-left-thick date-cell">
          {{reservation?.createDate ? (reservation?.createDate | date:'MM/dd/yy h:mm:ss a') : '—'}}
        </td>
        <td class="text-center date-cell">
          {{reservation?.lastUpdate ? (reservation?.lastUpdate | date:'MM/dd/yy h:mm:ss a') : '—'}}
        </td>


        <td class="text-center border-left-thick">
          {{(reservation?.stmtSummeryAPI?.maintenanceCreditTotal || 0)| statementAmount}}
        </td>
        <td class="text-center">
          {{(reservation?.stmtSummeryAPI?.maintenancePaidByOwnerTotal || 0)| statementAmount}}
        </td>


        <td class="text-center border-left-thick">
          {{(reservation?.stmtSummeryAPI?.housekeepingCreditTotal || 0)| statementAmount}}
        </td>
        <td class="text-center">
          {{(reservation?.stmtSummeryAPI?.housekeepingPaidByOwnerTotal || 0)| statementAmount}}
        </td>


        <td class="text-center border-left-thick">
          {{reservation?.ownerStmtId}}
        </td>


        <!-- {{getResStatusName(reservation.stmtStatus)}}</td> -->
        <!-- <td style="white-space: nowrap;">{{reservation.startDate|date:'MM/dd/yy EEEEEE'}}</td>
<td style="white-space: nowrap;">{{reservation.endDate|date:'MM/dd/yy EEEEEE'}}</td> -->


      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      @if (pageTotals; as t) {
      <tr class="owner-stmt-totals-row">
        <td></td>
        <td class="text-end fw-bold" colspan="3">Totals ({{ t.rowCount }} rows on page):</td>
        <td class="text-center fw-bold">{{ t.paidNights }}</td>
        <td class="text-center fw-bold">{{ t.occupancyRateAvg | number:'1.0-0' }} %</td>
        <td class="text-center fw-bold">{{ t.guestNight }}</td>
        <td class="text-center fw-bold">{{ t.ownerNights }}</td>
        <td class="text-center fw-bold">{{ t.ownerGuestNights }}</td>
        <td class="text-center fw-bold">{{ t.maintenanceNights }}</td>
        <td></td>
        <td class="text-center fw-bold border-left-thick">{{ t.rentalRevenue | statementAmount }}</td>
        <td class="text-center fw-bold border-left-thick">{{ t.paymentToOwner | statementAmount }}</td>
        <td class="text-center fw-bold border-left-thick">{{ t.maintenanceAndHousekeepingTotal | statementAmount }}</td>
        <td class="text-center fw-bold">{{ t.maintenanceAndHousekeepingPaidByKbmTotal | statementAmount }}</td>
        <td class="text-center fw-bold">{{ t.maintenanceAndHousekeepingPaidByOwnerTotal | statementAmount }}</td>
        <td class="text-center fw-bold border-left-thick">{{ t.mgntExpense | statementAmount }}</td>
        <td class="text-center fw-bold">{{ t.maintenancePaidByOwnerTotal | statementAmount }}</td>
        <td class="text-center fw-bold">{{ t.housekeepingPaidByOwnerTotal | statementAmount }}</td>
        <td class="text-center fw-bold">{{ t.taxExpense | statementAmount }}</td>
        <td class="text-center fw-bold">{{ t.totalExpense | statementAmount }}</td>
        <td class="text-center fw-bold border-left-thick">{{ t.startingBalance | statementAmount }}</td>
        <td class="text-center fw-bold">{{ t.endingBalance | statementAmount }}</td>
        <td class="text-center fw-bold border-left-thick">{{ t.discrepancyAmount | statementAmount }}</td>
        <td></td>
        <td class="text-center fw-bold border-left-thick">{{ t.matchCount }} ✓ / {{ t.mismatchCount }} ✗</td>
        <td></td>
        <td></td>
        <td class="text-center fw-bold border-left-thick">{{ t.maintenanceCreditTotal | statementAmount }}</td>
        <td class="text-center fw-bold">{{ t.maintenancePaidByOwnerTotal | statementAmount }}</td>
        <td class="text-center fw-bold border-left-thick">{{ t.housekeepingCreditTotal | statementAmount }}</td>
        <td class="text-center fw-bold">{{ t.housekeepingPaidByOwnerTotal | statementAmount }}</td>
        <td></td>
      </tr>
      }
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="26" class="text-center fw-bold p-2">
          {{loading ? 'Loading Statements...' : 'No Statements Found'}}
        </td>
      </tr>

    </ng-template>
    <ng-template pTemplate=" paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} -
        {{recordTotal> 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows +
          lazyLoadEvent.first) : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
  </p-table>
  <p-contextMenu #stmtContextMenu appendTo="body" [model]="stmtContextMenuItems"></p-contextMenu>
</div>

<!-- Bulk Update Dialog -->
<p-dialog [(visible)]="showBulkUpdateDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{width: '550px'}" header="Bulk Update Statements" [baseZIndex]="10" styleClass="bulk-update-dialog"
  (onHide)="showBulkUpdateDialog = false">
  @if (bulkUpdateForm) {
  <div [formGroup]="bulkUpdateForm" class="p-fluid">
    <div class="p-field mb-2">
      <label for="bulkStatementMonth" class="required fw-bold">Statement Month/Year</label>
      <p-calendar appendTo="body" id="bulkStatementMonth" formControlName="statementMonth" appendTo="body" view="month"
        dateFormat="M yy" [showIcon]="false" [style]="{'width':'100%'}" [readonlyInput]="true"
        placeholder="Select Month/Year" [showButtonBar]="true">
      </p-calendar>
      @for (validation of bulkUpdateValidationMessages.statementMonth; track validation) {
      <span>
        @if (bulkUpdateForm.get('statementMonth')?.hasError(validation.type) &&
        (bulkUpdateForm.get('statementMonth')?.dirty || bulkUpdateForm.get('statementMonth')?.touched)) {
        <small class="p-error">{{validation.message}}
        </small>
        }
      </span>
      }
    </div>
    <div class="p-field mb-2">
      <label for="bulkProperties" class="fw-bold">Properties</label>
      <p-multiSelect appendTo="body" dropdownIcon="fa fa-caret-down" id="bulkProperties" formControlName="properties"
        [options]="properties" optionLabel="propertyCode" optionValue="shortTermRentalId" appendTo="body"
        [style]="{'width':'100%'}" placeholder="Select Properties" [filter]="true"
        filterPlaceholder="Search properties">
      </p-multiSelect>
      @for (validation of bulkUpdateValidationMessages.properties; track validation) {
      <span>
        @if (bulkUpdateForm.get('properties')?.hasError(validation.type) && (bulkUpdateForm.get('properties')?.dirty ||
        bulkUpdateForm.get('properties')?.touched)) {
        <small class="p-error">{{validation.message}}
        </small>
        }
      </span>
      }
    </div>
    <div class="p-field mb-2">
      <label for="bulkOldStatus" class="required fw-bold">Old Status</label>
      <p-dropdown appendTo="body" dropdownIcon="fa fa-caret-down" id="bulkOldStatus" formControlName="oldStatus"
        [options]="statusListWithoutPublished" optionLabel="label" optionValue="value" appendTo="body"
        [style]="{'width':'100%'}" placeholder="Select Old Status" [filter]="false">
      </p-dropdown>
      @for (validation of bulkUpdateValidationMessages.oldStatus; track validation) {
      <span>
        @if (bulkUpdateForm.get('oldStatus')?.hasError(validation.type) && (bulkUpdateForm.get('oldStatus')?.dirty ||
        bulkUpdateForm.get('oldStatus')?.touched)) {
        <small class="p-error">{{validation.message}}
        </small>
        }
      </span>
      }
    </div>
    <div class="p-field mb-2">
      <label for="bulkNewStatus" class="required fw-bold">New Status</label>
      <p-dropdown appendTo="body" dropdownIcon="fa fa-caret-down" id="bulkNewStatus" formControlName="newStatus"
        [options]="statusList" optionLabel="label" optionValue="value" appendTo="body" [style]="{'width':'100%'}"
        placeholder="Select New Status" [filter]="false">
      </p-dropdown>
      @for (validation of bulkUpdateValidationMessages.newStatus; track validation) {
      <span>
        @if (bulkUpdateForm.get('newStatus')?.hasError(validation.type) && (bulkUpdateForm.get('newStatus')?.dirty ||
        bulkUpdateForm.get('newStatus')?.touched)) {
        <small class="p-error">{{validation.message}}
        </small>
        }
      </span>
      }
    </div>
  </div>
  }

  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
      (click)="showBulkUpdateDialog = false; bulkUpdateForm?.reset()" class="p-button-text"></button>
    <button pButton pRipple type="button" (click)="confirmBulkUpdate()" class="p-button-primary" [disabled]="loading">
      @if (loading) {
      <span>
        <i class="pi pi-spin pi-spinner" style="margin-right: 0.5rem;"></i>
        Updating...
      </span>
      }
      @if (!loading) {
      <span><i class="pi pi-check"></i> Apply Update</span>
      }
    </button>
  </ng-template>
</p-dialog>

<!-- Regenerate Bulk Statement Dialog -->
<p-dialog [(visible)]="showRegenerateBulkDialog" [modal]="true" [closable]="true" [draggable]="false"
  [resizable]="false" [style]="{width: '400px'}"
  [header]="regenerateDialogType === 'expenses' ? 'Regenerate Statement Expenses' : 'Regenerate Bulk Statement'"
  [baseZIndex]="10" (onHide)="showRegenerateBulkDialog = false">
  @if (regenerateBulkForm) {
  <div [formGroup]="regenerateBulkForm" class="p-fluid">
    <div class="p-field mb-2">
      <label for="regenerateMonthYear" class="required fw-bold">Month / Year</label>
      <p-calendar appendTo="body" id="regenerateMonthYear" formControlName="monthYear" view="month" dateFormat="M yy"
        [showIcon]="false" [style]="{'width':'100%'}" [readonlyInput]="true" placeholder="Select Month/Year"
        [showButtonBar]="true">
      </p-calendar>
      @if (regenerateBulkForm.get('monthYear')?.invalid && (regenerateBulkForm.get('monthYear')?.dirty ||
      regenerateBulkForm.get('monthYear')?.touched)) {
      <small class="p-error">
        Month/Year is required
      </small>
      }
    </div>
  </div>
  }
  @if (regenerateDialogType === 'bulk') {
  <div class="bg-warning p-2 rounded">
    <p><i class="pi pi-info-circle"></i> This will regenerate all statement expenses along with reservations.</p>
  </div>
  }
  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
      (click)="showRegenerateBulkDialog = false; regenerateBulkForm?.reset()" class="p-button-text"></button>
    <button pButton pRipple type="button" (click)="confirmRegenerateBulk()" class="p-button-primary"
      [disabled]="regenerateBulkLoading">
      @if (regenerateBulkLoading) {
      <span>
        <i class="pi pi-spin pi-spinner" style="margin-right: 0.5rem;"></i>
        Regenerating...
      </span>
      }
      @if (!regenerateBulkLoading) {
      <span>
        <i class="pi pi-refresh"></i>
        {{ regenerateDialogType === 'expenses' ? 'Regenerate Expenses' : 'Regenerate Statements' }}
      </span>
      }
    </button>
  </ng-template>
</p-dialog>

<!-- Bulk Mail Statements Dialog -->
<p-dialog [(visible)]="showBulkMailDialog" [modal]="true" [closable]="!bulkMailLoading" [draggable]="false"
  [resizable]="false" [style]="{width: '640px'}" header="Bulk Mail Statements" [baseZIndex]="10"
  (onHide)="showBulkMailDialog = false; bulkMailPassword = ''; bulkMailError = ''">

  <!-- Warning banner -->
  <div class="bulk-mail-warning mb-3">
    <i class="pi pi-exclamation-triangle bulk-mail-warning-icon"></i>
    <div>
      <p class="mb-1"><strong>Warning:</strong> This will email <strong>{{ selectedCount }}</strong> selected statement(s)
        to their owners. Only Published statements will be sent.</p>
      <p class="mb-0">This action cannot be undone. Complete every checklist item below, then type the confirmation phrase.</p>
    </div>
  </div>

  <!-- Progress indicator -->
  <div class="checklist-progress mb-3">
    <div class="checklist-progress-header">
      <span class="checklist-progress-label">
        <i class="pi pi-list-check"></i> Pre-Send Checklist
      </span>
      <span class="checklist-progress-count"
        [ngClass]="{'checklist-progress-complete': bulkMailChecklistComplete, 'checklist-progress-partial': !bulkMailChecklistComplete}">
        {{ checklistCompletedCount }} of {{ checklistTotalCount }} complete
      </span>
    </div>
    <div class="checklist-progress-bar-track">
      <div class="checklist-progress-bar-fill"
        [style.width.%]="(checklistCompletedCount / checklistTotalCount) * 100"
        [ngClass]="{'checklist-progress-bar-complete': bulkMailChecklistComplete}">
      </div>
    </div>
  </div>

  <!-- Checklist items -->
  <div class="checklist-items mb-3">

    <div class="checklist-item" [ngClass]="{'checklist-item-checked': bulkMailChecklist.bankReconciled}">
      <p-checkbox inputId="chkBankRec" [binary]="true" [(ngModel)]="bulkMailChecklist.bankReconciled"
        [disabled]="bulkMailLoading" (onChange)="onChecklistChange()"></p-checkbox>
      <label for="chkBankRec" class="checklist-item-label">
        <span class="checklist-item-number">1</span>
        <span class="checklist-item-text">
          Bank reconciliation is complete for the period
          <span class="checklist-item-hint">Accounting has reconciled all trust accounts for this statement month.</span>
        </span>
        @if (bulkMailChecklist.bankReconciled) {
        <i class="pi pi-check-circle checklist-item-check-icon"></i>
        }
      </label>
    </div>

    <div class="checklist-item" [ngClass]="{'checklist-item-checked': bulkMailChecklist.qbPaymentsEntered}">
      <p-checkbox inputId="chkQB" [binary]="true" [(ngModel)]="bulkMailChecklist.qbPaymentsEntered"
        [disabled]="bulkMailLoading" (onChange)="onChecklistChange()"></p-checkbox>
      <label for="chkQB" class="checklist-item-label">
        <span class="checklist-item-number">2</span>
        <span class="checklist-item-text">
          All owner payments are entered in QuickBooks
          <span class="checklist-item-hint">Bijoy has completed all QB entries for the period.</span>
        </span>
        @if (bulkMailChecklist.qbPaymentsEntered) {
        <i class="pi pi-check-circle checklist-item-check-icon"></i>
        }
      </label>
    </div>

    <div class="checklist-item" [ngClass]="{'checklist-item-checked': bulkMailChecklist.beginEndBalancesVerified}">
      <p-checkbox inputId="chkBalances" [binary]="true" [(ngModel)]="bulkMailChecklist.beginEndBalancesVerified"
        [disabled]="bulkMailLoading" (onChange)="onChecklistChange()"></p-checkbox>
      <label for="chkBalances" class="checklist-item-label">
        <span class="checklist-item-number">3</span>
        <span class="checklist-item-text">
          Beginning/ending balances verified for all owners
          <span class="checklist-item-hint">Each statement's starting balance matches the prior month's ending balance.</span>
        </span>
        @if (bulkMailChecklist.beginEndBalancesVerified) {
        <i class="pi pi-check-circle checklist-item-check-icon"></i>
        }
      </label>
    </div>

    <div class="checklist-item" [ngClass]="{'checklist-item-checked': bulkMailChecklist.negativeBalancesReviewed}">
      <p-checkbox inputId="chkNegBal" [binary]="true" [(ngModel)]="bulkMailChecklist.negativeBalancesReviewed"
        [disabled]="bulkMailLoading" (onChange)="onChecklistChange()"></p-checkbox>
      <label for="chkNegBal" class="checklist-item-label">
        <span class="checklist-item-number">4</span>
        <span class="checklist-item-text">
          No negative ending balances — or all have been reviewed and approved
          <span class="checklist-item-hint">Any owner with a negative net has been identified and the balance is intentional.</span>
        </span>
        @if (bulkMailChecklist.negativeBalancesReviewed) {
        <i class="pi pi-check-circle checklist-item-check-icon"></i>
        }
      </label>
    </div>

    <div class="checklist-item" [ngClass]="{'checklist-item-checked': bulkMailChecklist.reservationsReconciled}">
      <p-checkbox inputId="chkRezRec" [binary]="true" [(ngModel)]="bulkMailChecklist.reservationsReconciled"
        [disabled]="bulkMailLoading" (onChange)="onChecklistChange()"></p-checkbox>
      <label for="chkRezRec" class="checklist-item-label">
        <span class="checklist-item-number">5</span>
        <span class="checklist-item-text">
          All reservations reconciled for the period
          <span class="checklist-item-hint">Reservation income, expense reconciliation page shows all green checkmarks.</span>
        </span>
        @if (bulkMailChecklist.reservationsReconciled) {
        <i class="pi pi-check-circle checklist-item-check-icon"></i>
        }
      </label>
    </div>

    <div class="checklist-item" [ngClass]="{'checklist-item-checked': bulkMailChecklist.statementsSpotChecked}">
      <p-checkbox inputId="chkSpot" [binary]="true" [(ngModel)]="bulkMailChecklist.statementsSpotChecked"
        [disabled]="bulkMailLoading" (onChange)="onChecklistChange()"></p-checkbox>
      <label for="chkSpot" class="checklist-item-label">
        <span class="checklist-item-number">6</span>
        <span class="checklist-item-text">
          Statements previewed for at least 3 random owners
          <span class="checklist-item-hint">PDFs opened and numbers spot-checked — revenue, expenses, and net payment look correct.</span>
        </span>
        @if (bulkMailChecklist.statementsSpotChecked) {
        <i class="pi pi-check-circle checklist-item-check-icon"></i>
        }
      </label>
    </div>

    <div class="checklist-item" [ngClass]="{'checklist-item-checked': bulkMailChecklist.accountingManagerApproval}">
      <p-checkbox inputId="chkApproval" [binary]="true" [(ngModel)]="bulkMailChecklist.accountingManagerApproval"
        [disabled]="bulkMailLoading" (onChange)="onChecklistChange()"></p-checkbox>
      <label for="chkApproval" class="checklist-item-label">
        <span class="checklist-item-number">7</span>
        <span class="checklist-item-text">
          Accounting manager approval received
          <span class="checklist-item-hint">Jacki, Justin, or Sarah has signed off that statements are ready to send.</span>
        </span>
        @if (bulkMailChecklist.accountingManagerApproval) {
        <i class="pi pi-check-circle checklist-item-check-icon"></i>
        }
      </label>
    </div>

  </div>

  <!-- Confirmation phrase — only shown once all items are checked -->
  @if (bulkMailChecklistComplete) {
  <div class="checklist-unlocked-banner mb-2">
    <i class="pi pi-unlock"></i> All items confirmed. Enter the confirmation phrase to enable send.
  </div>
  <div class="p-field mb-2">
    <label for="bulkMailPassword" class="required fw-bold">Confirmation Phrase</label>
    <input id="bulkMailPassword" type="password" pInputText class="w-100" [(ngModel)]="bulkMailPassword"
      placeholder="Enter confirmation phrase" [disabled]="bulkMailLoading" autocomplete="off" />
  </div>
  } @else {
  <div class="checklist-locked-hint mb-2">
    <i class="pi pi-lock"></i> Confirmation phrase unlocks when all {{ checklistTotalCount }} items are checked.
  </div>
  }

  @if (bulkMailError) {
  <small class="p-error d-block">{{ bulkMailError }}</small>
  }
  @if (bulkMailProgress) {
  <div class="mt-2">
    <p class="mb-1">{{ bulkMailProgress }}</p>
  </div>
  }

  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" label="Reset Checklist" icon="pi pi-refresh"
      class="p-button-text p-button-secondary" (click)="resetChecklist()"
      [disabled]="bulkMailLoading"
      pTooltip="Clear all checklist items for this month and start over" tooltipPosition="top"></button>
    <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
      (click)="showBulkMailDialog = false; bulkMailPassword = ''; bulkMailError = ''" class="p-button-text"
      [disabled]="bulkMailLoading"></button>
    <button pButton pRipple type="button" (click)="confirmBulkMail()" class="p-button-danger"
      [disabled]="bulkMailLoading || !bulkMailChecklistComplete || !bulkMailPassword">
      @if (bulkMailLoading) {
      <span><i class="pi pi-spin pi-spinner" style="margin-right: 0.5rem;"></i>Sending...</span>
      }
      @if (!bulkMailLoading) {
      <span><i class="pi pi-send"></i> Send {{ selectedCount }} Statement(s)</span>
      }
    </button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showDeleteConfirmDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{width: '400px'}" header="Delete Statement" [baseZIndex]="10" (onHide)="cancelDeleteConfirm()">
  <p class="mb-3">To confirm deletion, enter the code below.</p>
  <div class="p-field">
    <label for="deleteCodeInput">Enter delete code</label>
    <input id="deleteCodeInput" type="text" pInputText class="w-100" [(ngModel)]="deleteCodeValue"
      placeholder="Enter delete code" [disabled]="deleteStatementLoading" (keydown.enter)="confirmDeleteStatement()" />
    @if (deleteCodeError) {
    <small class="p-error">{{ deleteCodeError }}</small>
    }
  </div>
  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" label="Cancel" icon="pi pi-times" (click)="cancelDeleteConfirm()"
      class="p-button-text" [disabled]="deleteStatementLoading"></button>
    <button pButton pRipple type="button" icon="pi pi-trash" (click)="confirmDeleteStatement()" class="p-button-danger"
      [disabled]="deleteStatementLoading">
      @if (deleteStatementLoading) {
      <span>
        <i class="pi pi-spin pi-spinner" style="margin-right: 0.5rem;"></i>
        Deleting...
      </span>
      }
      @if (!deleteStatementLoading) {
      <span>Delete</span>
      }
    </button>
  </ng-template>
</p-dialog>

<!-- Mark Paid dialog -->
<p-dialog [(visible)]="showMarkPaidDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{width: '440px'}" header="Mark Statement as Paid" [baseZIndex]="10" (onHide)="cancelMarkPaid()">

  <div *ngIf="markPaidRow" class="mb-3">
    <div class="fw-bold">{{ markPaidRow.propertyCode }}</div>
    <div class="text-muted" style="font-size:13px;">{{ markPaidRow.startDate | date:'MMM yyyy' }}</div>
  </div>

  <form *ngIf="markPaidForm" [formGroup]="markPaidForm">
    <div class="p-field mb-3">
      <label for="mpMethod" class="fw-bold d-block mb-1">Payment Method <span class="p-error">*</span></label>
      <p-dropdown id="mpMethod" formControlName="paymentMethod"
        [options]="paymentMethodOptions" optionLabel="label" optionValue="value"
        [style]="{width:'100%'}" appendTo="body"
        placeholder="Select method"></p-dropdown>
      <small class="p-error d-block" *ngIf="markPaidForm.get('paymentMethod')?.invalid && markPaidForm.get('paymentMethod')?.touched">
        Payment method is required.
      </small>
    </div>

    <div class="p-field mb-3">
      <label for="mpDate" class="fw-bold d-block mb-1">Paid Date <span class="p-error">*</span></label>
      <p-calendar id="mpDate" formControlName="paidDate"
        dateFormat="mm/dd/yy" [showIcon]="true" appendTo="body"
        [style]="{width:'100%'}" inputStyleClass="w-100"
        placeholder="MM/DD/YYYY"></p-calendar>
      <small class="p-error d-block" *ngIf="markPaidForm.get('paidDate')?.invalid && markPaidForm.get('paidDate')?.touched">
        Paid date is required.
      </small>
    </div>

    <div class="p-field mb-3">
      <label for="mpRef" class="fw-bold d-block mb-1">Payment Reference</label>
      <input id="mpRef" type="text" pInputText formControlName="paymentReference"
        class="w-100" placeholder="Check #, wire ref, etc." [disabled]="markPaidLoading" />
      <small class="text-muted d-block mt-1">Optional — check number, wire confirmation, etc.</small>
    </div>
  </form>

  @if (markPaidError) {
  <small class="p-error d-block mb-2">{{ markPaidError }}</small>
  }

  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
      class="p-button-text" (click)="cancelMarkPaid()" [disabled]="markPaidLoading"></button>
    <button pButton pRipple type="button" icon="pi pi-check-circle" (click)="confirmMarkPaid()"
      class="p-button-success" [disabled]="markPaidLoading">
      @if (markPaidLoading) {
      <span><i class="pi pi-spin pi-spinner" style="margin-right:0.5rem;"></i>Saving...</span>
      }
      @if (!markPaidLoading) {
      <span>Mark Paid</span>
      }
    </button>
  </ng-template>
</p-dialog>